import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installErrorBuffer } from './utils/errorBuffer';
import { installActionLog } from './utils/installActionLog';
import './index.css';

// Capture runtime errors + unhandled rejections in a ring buffer so the
// "Send Diagnostics" feature (#1847) can include them in support reports.
// Must run before render so we catch errors thrown during initial mount.
installErrorBuffer();

// Capture clicks / nav / submit / API calls into a chronological action
// log (#1895). Lets support replay the exact sequence of actions the
// rep took leading up to a bug, without needing full DOM session
// replay. Bundled into every diagnostics submission.
installActionLog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
